import React, { useState, useEffect } from "react";
import { Globe, Phone, MessageCircle } from "lucide-react";

const LANGUAGES = [
  { code: "en", label: "English", flag: "\uD83C\uDDEC\uD83C\uDDE7" },
  { code: "fr", label: "Fran\u00E7ais", flag: "\uD83C\uDDEB\uD83C\uDDF7" },
  { code: "pt", label: "Portugu\u00EAs", flag: "\uD83C\uDDF5\uD83C\uDDF9" },
  { code: "es", label: "Espa\u00F1ol", flag: "\uD83C\uDDEA\uD83C\uDDF8" },
  { code: "ar", label: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629", flag: "\uD83C\uDDF8\uD83C\uDDE6" },
  { code: "de", label: "Deutsch", flag: "\uD83C\uDDE9\uD83C\uDDEA" },
  { code: "it", label: "Italiano", flag: "\uD83C\uDDEE\uD83C\uDDF9" },
  { code: "nl", label: "Nederlands", flag: "\uD83C\uDDF3\uD83C\uDDF1" },
  { code: "tr", label: "T\u00FCrk\u00E7e", flag: "\uD83C\uDDF9\uD83C\uDDF7" },
  { code: "sw", label: "Kiswahili", flag: "\uD83C\uDDF0\uD83C\uDDEA" },
  { code: "ha", label: "Hausa", flag: "\uD83C\uDDF3\uD83C\uDDEC" },
  { code: "yo", label: "Yor\u00F9b\u00E1", flag: "\uD83C\uDDF3\uD83C\uDDEC" },
  { code: "ig", label: "Igbo", flag: "\uD83C\uDDF3\uD83C\uDDEC" },
  { code: "am", label: "\u12A0\u121B\u122D\u129B", flag: "\uD83C\uDDEA\uD83C\uDDF9" },
  { code: "zu", label: "isiZulu", flag: "\uD83C\uDDFF\uD83C\uDDE6" },
  { code: "hi", label: "\u0939\u093F\u0928\u094D\u0926\u0940", flag: "\uD83C\uDDEE\uD83C\uDDF3" },
  { code: "zh", label: "\u4E2D\u6587", flag: "\uD83C\uDDE8\uD83C\uDDF3" },
  { code: "ja", label: "\u65E5\u672C\u8A9E", flag: "\uD83C\uDDEF\uD83C\uDDF5" },
  { code: "ko", label: "\uD55C\uAD6D\uC5B4", flag: "\uD83C\uDDF0\uD83C\uDDF7" },
  { code: "ru", label: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439", flag: "\uD83C\uDDF7\uD83C\uDDFA" },
  { code: "pl", label: "Polski", flag: "\uD83C\uDDF5\uD83C\uDDF1" },
  { code: "id", label: "Bahasa", flag: "\uD83C\uDDEE\uD83C\uDDE9" },
  { code: "th", label: "\u0E44\u0E17\u0E22", flag: "\uD83C\uDDF9\uD83C\uDDED" },
  { code: "vi", label: "Ti\u1EBFng Vi\u1EC7t", flag: "\uD83C\uDDFB\uD83C\uDDF3" },
];

// Map country codes to language codes
const COUNTRY_TO_LANG = {
  NG: "en", GH: "en", KE: "sw", ZA: "en", TZ: "sw", UG: "en", CM: "fr", SN: "fr",
  ET: "am", RW: "fr", EG: "ar", ZM: "en", CI: "fr", ML: "fr", BF: "fr", NE: "fr",
  BJ: "fr", TG: "fr", GN: "fr", CG: "fr", CD: "fr", GA: "fr", AO: "pt", MZ: "pt",
  GB: "en", US: "en", CA: "en", AU: "en", NZ: "en", IE: "en", DE: "de", FR: "fr",
  IT: "it", ES: "es", NL: "nl", PT: "pt", BE: "fr", SE: "en", NO: "en", DK: "en",
  PL: "pl", CH: "de", GR: "en", RO: "en", CZ: "en", HU: "en", AT: "de",
  BR: "pt", MX: "es", AR: "es", CO: "es", CL: "es", PE: "es",
  IN: "hi", PK: "en", BD: "en", PH: "en", ID: "id", MY: "en",
  TH: "th", VN: "vi", AE: "ar", SA: "ar", TR: "tr",
  JP: "ja", KR: "ko", CN: "zh", RU: "ru",
};

// Map country codes to flags
const COUNTRY_FLAGS = {
  NG: "\uD83C\uDDF3\uD83C\uDDEC", GH: "\uD83C\uDDEC\uD83C\uDDED", KE: "\uD83C\uDDF0\uD83C\uDDEA",
  ZA: "\uD83C\uDDFF\uD83C\uDDE6", US: "\uD83C\uDDFA\uD83C\uDDF8", GB: "\uD83C\uDDEC\uD83C\uDDE7",
  FR: "\uD83C\uDDEB\uD83C\uDDF7", DE: "\uD83C\uDDE9\uD83C\uDDEA", BR: "\uD83C\uDDE7\uD83C\uDDF7",
  IN: "\uD83C\uDDEE\uD83C\uDDF3", EG: "\uD83C\uDDEA\uD83C\uDDEC", CM: "\uD83C\uDDE8\uD83C\uDDF2",
  SA: "\uD83C\uDDF8\uD83C\uDDE6", AE: "\uD83C\uDDE6\uD83C\uDDEA", TR: "\uD83C\uDDF9\uD83C\uDDF7",
  JP: "\uD83C\uDDEF\uD83C\uDDF5", CN: "\uD83C\uDDE8\uD83C\uDDF3", RU: "\uD83C\uDDF7\uD83C\uDDFA",
  ES: "\uD83C\uDDEA\uD83C\uDDF8", IT: "\uD83C\uDDEE\uD83C\uDDF9", NL: "\uD83C\uDDF3\uD83C\uDDF1",
  PL: "\uD83C\uDDF5\uD83C\uDDF1", AU: "\uD83C\uDDE6\uD83C\uDDFA", CA: "\uD83C\uDDE8\uD83C\uDDE6",
  MX: "\uD83C\uDDF2\uD83C\uDDFD", AR: "\uD83C\uDDE6\uD83C\uDDF7", TZ: "\uD83C\uDDF9\uD83C\uDDFF",
  UG: "\uD83C\uDDFA\uD83C\uDDEC", ET: "\uD83C\uDDEA\uD83C\uDDF9", SN: "\uD83C\uDDF8\uD83C\uDDF3",
  RW: "\uD83C\uDDF7\uD83C\uDDFC", PT: "\uD83C\uDDF5\uD83C\uDDF9", ID: "\uD83C\uDDEE\uD83C\uDDE9",
  TH: "\uD83C\uDDF9\uD83C\uDDED", VN: "\uD83C\uDDFB\uD83C\uDDF3", KR: "\uD83C\uDDF0\uD83C\uDDF7",
  PH: "\uD83C\uDDF5\uD83C\uDDED", MY: "\uD83C\uDDF2\uD83C\uDDFE",
};

export { LANGUAGES };

const TopBar = () => {
  const [language, setLanguage] = useState(() => localStorage.getItem("fixedraws_lang") || "en");
  const [countryFlag, setCountryFlag] = useState("\uD83C\uDF0D");
  const [countryName, setCountryName] = useState("");

  useEffect(() => {
    // Auto-detect country on first visit
    if (!localStorage.getItem("fixedraws_country_detected")) {
      fetch("https://ipapi.co/json/")
        .then(r => r.json())
        .then(data => {
          if (data?.country_code) {
            const cc = data.country_code;
            const flag = COUNTRY_FLAGS[cc] || "\uD83C\uDF0D";
            setCountryFlag(flag);
            setCountryName(data.country_name || "");
            // Auto-set language
            const detectedLang = COUNTRY_TO_LANG[cc];
            if (detectedLang && !localStorage.getItem("fixedraws_lang")) {
              setLanguage(detectedLang);
              localStorage.setItem("fixedraws_lang", detectedLang);
            }
            localStorage.setItem("fixedraws_country_detected", cc);
            localStorage.setItem("fixedraws_country_flag", flag);
            localStorage.setItem("fixedraws_country_name", data.country_name || "");
          }
        })
        .catch(() => {});
    } else {
      setCountryFlag(localStorage.getItem("fixedraws_country_flag") || "\uD83C\uDF0D");
      setCountryName(localStorage.getItem("fixedraws_country_name") || "");
    }
  }, []);

  const handleLangChange = (e) => {
    setLanguage(e.target.value);
    localStorage.setItem("fixedraws_lang", e.target.value);
  };

  const currentLang = LANGUAGES.find(l => l.code === language);

  return (
    <div className="bg-gray-900 text-gray-300 text-xs fixed top-0 left-0 right-0 z-[60]" data-testid="top-bar">
      <div className="max-w-7xl mx-auto px-4 flex items-center justify-between h-8">
        <div className="flex items-center gap-2" data-testid="country-display">
          <span className="text-sm">{countryFlag}</span>
          {countryName && <span className="hidden sm:inline text-gray-400">{countryName}</span>}
        </div>
        <div className="flex items-center gap-3">
          {/* Madam Precious — call + WhatsApp */}
          <div className="flex items-center gap-1.5" data-testid="topbar-precious-contact">
            <a
              href="tel:+2348068833390"
              className="flex items-center gap-1 hover:text-white transition-colors"
              data-testid="topbar-call-btn"
              title="Call Madam Precious"
            >
              <Phone className="h-3 w-3 text-green-400" />
              <span className="hidden sm:inline font-medium">08068833390</span>
              <span className="hidden md:inline text-gray-500 text-[10px]">· Madam Precious</span>
            </a>
            <a
              href="https://wa.me/2348068833390?text=Hi%20Madam%20Precious%2C%20I%20need%20help%20with..."
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center hover:text-white transition-colors"
              data-testid="topbar-whatsapp-btn"
              title="WhatsApp Madam Precious"
            >
              <MessageCircle className="h-3 w-3 text-emerald-400" />
            </a>
          </div>
          <span className="hidden sm:inline text-gray-700">|</span>
          <div className="flex items-center gap-1.5">
            <Globe className="h-3 w-3 text-green-400" />
            <select
              value={language}
              onChange={handleLangChange}
              className="bg-transparent border-none text-gray-300 text-xs cursor-pointer focus:outline-none pr-1"
              data-testid="topbar-language-select"
            >
              {LANGUAGES.map(l => (
                <option key={l.code} value={l.code} className="bg-gray-900 text-gray-300">
                  {l.flag} {l.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
